import React from "react";
import { Dialog, Button } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ElevenLabsBetaDisclaimerModal = ({ open, onAcknowledge, onCancel }) => {
  const handleClose = (_event, reason) => {
    if (reason === "backdropClick") return;
    onCancel();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "14px",
          padding: "28px",
        },
      }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0,0,0,0.35)" },
      }}
    >
      <div className="flex items-center gap-2 mb-4">
        <InfoOutlinedIcon className="text-indigo-500" sx={{ fontSize: 28 }} />
        <h2 className="text-[22px] font-semibold text-gray-800">
          Eleven Labs (beta)
        </h2>
      </div>

      <p className="text-gray-600 text-[15px] leading-relaxed mb-4">
        Before adding this call action, please review the following:
      </p>

      <ul className="list-disc list-inside text-[15px] text-gray-700 space-y-2 mb-6">
        <li className="leading-snug">
          This feature is in <strong>beta</strong>. Your callers may experience bugs or unexpected behavior.
        </li>
        <li className="leading-snug">
          The ElevenLabs AI Agent integration is currently offered <strong>free of charge</strong> while in beta, but it will likely require a paid add-on in the future.
        </li>
      </ul>

      <div className="flex justify-end gap-3">
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{
            textTransform: "none",
            borderRadius: "10px",
            px: 3,
            py: 0.4,
            fontSize: "15px",
            color: "#374151",
            borderColor: "#D1D5DB",
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onAcknowledge}
          sx={{
            textTransform: "none",
            borderRadius: "10px",
            px: 3,
            py: 0.4,
            fontSize: "15px",
          }}
        >
          I understand, continue
        </Button>
      </div>
    </Dialog>
  );
};

export default ElevenLabsBetaDisclaimerModal;
